export default __webpack_public_path__ + "static/media/asia.06289e67.png";